'use client'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

interface TestimonialWillProps {
  namespace: string
}

export default function TestimonialWill({ namespace }: TestimonialWillProps) {
    const t = useTranslations(namespace)

    return (
        <section className="py-16 md:py-32">
            <div className="mx-auto max-w-7xl px-6">
                <div className="flex flex-col items-center justify-center gap-8 lg:flex-row lg:gap-16">
                    {/* Portrait Image */}
                    <div className="flex shrink-0 items-center justify-center">
                        <div className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96">
                            <div className="absolute inset-0 rounded-3xl overflow-hidden shadow-2xl">
                                <Image
                                    src="/willem-vanhoeve-7-laux-la-grange-rental.png"
                                    alt="Willem Vanhoeve - MTB, ski and snowboard rental expert at 7 Laux La Grange"
                                    fill
                                    sizes="(max-width: 768px) 256px, (max-width: 1024px) 320px, 384px"
                                    className="object-cover"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Testimonial Content */}
                    <div className="max-w-xl">
                        <blockquote>
                            <p className="text-lg font-bold sm:text-xl md:text-3xl font-[family-name:var(--font-roboto-slab)]">{t('quote')}</p>

                            <div className="mt-8 flex items-center">
                                <div className="space-y-1 border-l pl-4">
                                    <cite className="font-bold text-lg">{t('name')}</cite>
                                    <span className="text-foreground/90 block text-base">{t('title')}</span>
                                </div>
                            </div>
                        </blockquote>
                    </div>
                </div>
            </div>
        </section>
    )
}
